
import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../../../theme";

import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import { WarehouseInvoiceCard } from "../../../../../components/global/cards/financial/InvoiceCard";
import ButtonGroup from "../../../../../components/theme/buttons/ButtonGroup";
import ShLabel from "../../../../../components/theme/label/ShLabel";
import ShLabelSkeleton from "../../../../../components/theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../../../components/theme/skeleton/ShTextSkeleton";
import Text from "../../../../../components/theme/text/Text";
import { useGetInvoicesQuery } from "../../../../../newapi/financial/invoiceSlice";
import { formatPrice } from "../../../../../utils/helpers";
import { general_states } from "../../../../../utils/staticEnums";

import ShDataGrid2 from "../../../../../components/theme/datagrid2/ShDataGrid2";
import SidepanelLoader from "../../../../../components/theme/sidepanel2/SidepanelLoader";
import { getInvoiceStateData } from "../../../../../utils/labelColorText";
import ShDataGrid3 from "../../../../../components/theme/datagrid3/ShDataGrid3";

const SpInvoiceDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpInvoiceDetails/SpInvoiceDetails"));

const GridActions = (props) => {
    const theme = useTheme();
    return (
        <Box display="flex" alignItems="center" justifyContent="space-between" flex={1} gap={2}>
            <ButtonGroup version={2}>
            </ButtonGroup>
        </Box>
    )
}

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,

};

const All = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [isExtended, setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();
    
    const ref = useRef();
    const [config, setConfig] = useState();

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
        });

        return () => {
        }
    },[]);

    const handleOpen = () => {
        setAddModalOpen(true);
    }
    
    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }

    const handleClose = () => {
        setAddModalOpen(false);
    };

    const [relationId, setRelationId] = useState();
    const relationIdRef = useRef(relationId);
    
    const [invoiceId, setInvoiceId] = useState();
    const invoiceIdRef = useRef(invoiceId);
    
    const getInvoice = (params) => {
        if (!params) return;
    
        const newInvoiceId = parseInt(params.row.id);
        // Only update state if the pickingJobListId has actually changed
        if (invoiceIdRef.current !== newInvoiceId) {
            if(!spLoading) {
                setSpLoading(true);
            } 
            setInvoiceId(newInvoiceId);
            invoiceIdRef.current = newInvoiceId; // Update the ref to the new value
        }
            setIsExtended(true);
    };

    const columns = [
        {
            field: "number",
            headerName: t("number"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
    
                return params.row.number;
            }
        },
        {
            field: "state", 
            headerName: t("status"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                const stateData = getInvoiceStateData(params.row.state, theme);
                let labelcolor = stateData.labelcolor;
                let labeltext = stateData.labeltext;
                
                return (
                    <ShLabel size={32} palette="normal" variant={labelcolor}>
                      {t(labeltext)}
                    </ShLabel>
                  );
              }
        },
        {
            field: "date", 
            headerName: t("invoice_date"),
            flex:1,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                let date = params.row.date && params.row.date !== null ? new Date(params.row.date) : undefined;
              
                return (
                    <Text>
                        {date ? date.toLocaleDateString(i18n.language) : "-"}
                    </Text>
                );
            }
        },
        {
            field: "totalPrice", 
            headerName: t("total_price"),
            flex:1,
            shFilter: {
                type: "number"
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return formatPrice(i18n, params.row.totalPrice);
            }
        },
        {
            field: "period", 
            headerName: t("period"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                let startDate = params.row.startDate && params.row.startDate !== null ? new Date(params.row.startDate) : undefined;
                let endDate = params.row.endDate && params.row.endDate !== null ? new Date(params.row.endDate) : undefined;
              
                return (
                    <Text>
                        {startDate.toLocaleDateString(i18n.language)} - {endDate ? endDate.toLocaleDateString(i18n.language) : t("present")}
                    </Text>
                );
            }
        },
        {
            field: "externalReference", 
            headerName: t("external_reference"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return params.row.externalReference;
            }
        },
        {
            field: "totalLines",
            headerName: t("invoicelines"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
    
                return params.row.totalLines;
            }
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                // WarehouseInvoiceCard
                return (
                    <WarehouseInvoiceCard
                        onClick={() => getInvoice(params)}
                        skeleton={params.row.skeleton}
                        {...params.row}
                    />
                    // <ShTextSkeleton/>
                )
            }
        },
    ];

    return (
        <Box height={1} ref={ref} display={"flex"} flexDirection={"column"}>
            {/* <GridActions></GridActions> */}
            <ShDataGrid3 
                key={theme.palette.mode}
                gridKey="relations.financial.invoices"
                content={useGetInvoicesQuery}
                config={config}
                // gridActions={<GridActions></GridActions>} 
                title={t('all')}
                gridOptions={gridOptions} 
                sortModel={{field: columns[0].field,type:"DESC"}}
                columns={columns}
                onRowClick={getInvoice}
                >
            </ShDataGrid3>

            {spLoading && 
                <SpInvoiceDetails
                    invoiceId={invoiceId}
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                />
            }
        </Box>
    );
}

export default All;